/* global barnardos */
jQuery(document).ready(function($) {
  var body = $('body');
  var header = $('.header');
  var screen_admin_min = 783;
  var adminBarHeight = 0;
  var mainContent = $('#content');

  // Calculate admin bar
  if (body.hasClass('admin-bar')) {
    if ($(window).width() > screen_admin_min) {
      adminBarHeight = 32;
    } else {
      adminBarHeight = 46;
    }
  }

  /*** In view scroll ***/
  function elementsInView(sections) {

    // @ref: https://blog.adriaan.io/check-if-elements-are-in-viewport-in-vanilla-javascript.html

    var i

    // Don't run the rest of the code if every section is already visible
    if (document.querySelectorAll('.iv-wp:not(.el-iv)').length === 0) return

    // Run this code for every section in sections
    for (i = 0; i < sections.length; ++i) {
        if (sections[i].getBoundingClientRect().top <= window.innerHeight * 0.85 && sections[i].getBoundingClientRect().top > 0) {
            sections[i].classList.add('el-iv')
        }
    }

  }

  var sections = document.querySelectorAll('.iv-wp')

  // On load show elements currently in viewport
  elementsInView(sections)

    // On scroll check any new elements coming into viewport
  window.onscroll = function() {
    elementsInView(sections)
  }

  // Go to element
  $.fn.goToElement = function(offset) {
    offset = 70;
    if ($(this).length) {
      var offsetTop = $(this).offset().top,
        args = {
          scrollTop: (offsetTop - adminBarHeight - offset)
        };
      $('html, body').animate(args, 'fast');
    }
    return this;
  };
  body.on('click', '.anchor-link', function(e) {
    var _this = $(this);
    if (0 === _this.attr('href').indexOf('#')) {
      e.preventDefault();
      $(_this.attr('href')).goToElement();
    }
  });

  // Window events
  var onWindowEvents = function(foo, isReady, isLoad, isResize, isScroll) {
    if (isReady) {
      $(document).ready(foo);
    }

    if (isLoad) {
      $(window).bind('load', foo);
    }

    if (isResize) {
      var throttleResizing = _.throttle(foo, 100);
      $(window).bind('resize', throttleResizing);
    }

    if (isScroll) {
      var throttleScroll = _.throttle(foo, 10);
      $(window).bind('scroll', throttleScroll);
    }
  };

  // Balance elements
  var balanceElements = function(container, clr, gapDelta) {
    clr = (typeof clr !== 'undefined' ? clr : false);
    gapDelta = (typeof gapDelta !== 'undefined' ? gapDelta : 10);
    var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = [],
      el,
      currentDiv,
      topPosition = 0;
    var c = $(container).filter(':visible');
    if (!c.length) {
      return false;
    }
    if (!clr) {
      c.css('height', 'auto');
    } else {
      c.removeAttr('style');
    }
    c.each(function() {
      el = $(this);
      topPosition = el.offset().top;
      if ((currentRowStart < (topPosition + gapDelta)) && (currentRowStart > (topPosition - gapDelta))) {
        rowDivs.push(el);
        currentTallest = (currentTallest < el.outerHeight()) ? (el.outerHeight()) : (currentTallest);
      } else {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].css('height', currentTallest + 'px');
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPosition;
        currentTallest = el.outerHeight();
        rowDivs.push(el);
      }
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].css('height', currentTallest + 'px');
      }
    });
    return true;
  };

  var balanceAll = function() {
    balanceElements($('.balance-elements'), false, 30);
    balanceElements($('.balance-elements-2'), false, 30);
  };

  onWindowEvents(balanceAll, 1, 1, 1, 0);

  // Side menu
  header.on('click', '.navbar-toggler', function(e) {
    e.preventDefault();
    if (body.hasClass('side-menu-open')) {
      body.addClass('side-menu-closing');
      setTimeout(function() {
        body.removeClass('side-menu-open side-menu-closing');
      }, 400);
    } else {
      body.addClass('side-menu-open');
    }
  });

  // Mobile dropdown menu
  var toggleHtml = '<a href="#" class="dropdown-menu-toggle d-lg-none"><span></span></a>';
  header.find('.menu > li.menu-item-has-children > a').after(toggleHtml);
  $(document).on('click', '.dropdown-menu-toggle, .dropdown-menu-toggle + a', function(e) {
    if ($(window).width() < 992) {
      e.preventDefault();
      $(this).closest('.menu-item-has-children').find('.dropdown-menu-toggle').toggleClass('toggle');
      //$(this).closest('.menu-item-has-children').children('ul').slideToggle();
    }
  });

  $(document).ready(function() {
    $('.navbar-toggler').click(function() {
      $(this).toggleClass('is-active');
    });
  });

  $(document).ready(function() {
    $('.quiz').click(function() {
      $('.quiz').removeClass('active');
      $(this).addClass('active');
    });
  });

  // $(document).ready(function () {
  //     $(".quiz-2").click(function () {
  //         $(".quiz-2").removeClass("active-2");
  //         $(this).addClass("active-2");
  //     });
  // });

  $(document).ready(function() {
    $('.footer h5').click(function(e) {
      e.preventDefault();

      var $this = $(this);
      var menu = $this.parent().find('.menu');

      if (menu.hasClass('show')) {
        menu.removeClass('show');
        menu.slideUp(350);
      } else {
        menu.addClass('show');
        menu.slideDown(350);
      }
    });
  });

  // WOW animate
  // new WOW({
  //     boxClass: 'wow',
  //     animateClass: 'animated',
  //     offset: 0,
  //     mobile: false,
  //     live: true
  // }).init();

  // Scroll to top
  $(document).on('click', '.scroll-to-top', function(e) {
    e.preventDefault();
  });

  onWindowEvents(function() {
    if ($(window).scrollTop() > 400) {
      body.addClass('show-scrolling');
    } else {
      body.removeClass('show-scrolling');
    }
  }, 1, 0, 0, 1);

  // Take quiz page
  setTimeout(function(){
      $( '.elementor-widget-accordion' ).addClass('elementor-widget-accordion--active')
      $( '.elementor-tab-title' ).removeClass( 'elementor-active' );
      $( '.elementor-tab-content' ).css( 'display', 'none' );
  }, 10);

  $( '#elementor-tab-title-2251' ).click(function() {
      $('.quiz-hidden').addClass('quiz-hidden--show')
  });

  $( '#elementor-tab-title-2252' ).click(function() {
      $('.quiz-hidden').addClass('quiz-hidden--show')
  });

  $('.elementor-tab-title').click(function() {
      $(this).closest('section.elementor-element')
          .next('section.elementor-element')
          .find('.quiz-row')
          .removeClass("row-hidden");

      var currentWidth = $('.progress-bar').width() / $('.progress-bar-wrap').width() * 100;
      var newWidth = currentWidth + 7.692307692;

      if (!$(this).hasClass('elementor-element--clicked')) {
          $('.progress-bar').css('width', newWidth + '%')
          var questionNumber = parseInt($('.progress-bar-number span').html(), 10);
          $('.progress-bar-number span').empty().append(questionNumber + 1)
      }

      $(this).closest('section.elementor-element').find('.elementor-tab-title').addClass('elementor-element--clicked');

      if(questionNumber === 12) {
          $('.progress-bar-number').empty().append('Thank you for completing the quiz!')
      }
  });
  // END Take quiz page

  // TODO: When the site is on SSL, add below feature to get nearest location
  /*if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(showPosition);
  } else {
    console.log('Geolocation is not supported by this browser.');
  }

  function showPosition(position) {
    // Load nearest location
    $.ajax({
      method: 'GET',
      url: barnardos.ajaxUrl,
      dataType: 'json',
      data: {
        action: 'store_search',
        lat: -33.86882,
        lng: 151.2093,
        max_results: 50,
        search_radius: 50,
        autoload: 1,
      }
    }).done(function(response) {
      if (response && response.length) {
        console.log(response);
      }
    }).always(function() {
    });

    console.log('Latitude: ' + position.coords.latitude + '<br>Longitude: ' + position.coords.longitude);
  }*/
});
